module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _vm._v("JOHN CABOT, 1497")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("S")]), _vm._v("oon after Columbus’s first voyage, another Italian sailed the Atlantic in search of Asia. Born in Italy about the same time as Columbus, John Cabot was a wealthy importer of Asian spices by the 1490s. With Columbus’s success, he began to look for a northern route through America to the Far East. Cabot approached King Henry VII of England for financing. Henry had earlier rebuffed Columbus and was eager to catch this opportunity. Cabot set sail from Bristol on May 20, 1497.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A month later he sighted the rugged coast of northern Newfoundland not far from where, 500 years previously, Scandinavian explorer Leif Eriksson had planted a colony. Cabot claimed the land for King Henry, which began the basis for England’s settlement of North America. Cabot returned to England, and in 1498 five ships left England for Newfoundland. Only one returned. Cabot and the rest of the expedition disappeared without a trace. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(02-138, 02-139)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img9.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa7d224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter003.vue
// module id = 84
// module chunks = 0